// max time to wait in ms for google places to load
const LOAD_TIMEOUT = 30000;

// ms to delay between checks
const CHECK_DELAY = 50;

export const googlePlacesLoadedExecutor = (
    resolve: (value: void | PromiseLike<void>) => void,
    reject: (reason?: any) => void,
    waited = 0,
) => {
    if (GooglePlacesLoadObserver.isGooglePlacesLoaded()) {
        resolve();
    } else if (waited > LOAD_TIMEOUT) {
        reject(
            new Error(
                `Google Places did not load in ${LOAD_TIMEOUT} milliseconds`,
            ),
        );
    } else {
        setTimeout(
            () =>
                googlePlacesLoadedExecutor(
                    resolve,
                    reject,
                    waited + CHECK_DELAY,
                ),
            CHECK_DELAY,
        );
    }
};

export class GooglePlacesLoadObserver {
    static instance: GooglePlacesLoadObserver;
    private loadPromise!: Promise<void>;

    constructor() {
        if (typeof GooglePlacesLoadObserver.instance !== 'undefined') {
            return GooglePlacesLoadObserver.instance;
        }

        GooglePlacesLoadObserver.instance = this;
        this.init();
    }

    private init() {
        this.loadPromise = new Promise(googlePlacesLoadedExecutor);
    }

    public static isGooglePlacesLoaded() {
        return (
            window &&
            window.google &&
            window.google.maps &&
            !!window.google.maps.places
        );
    }

    public static get() {
        const instance = new GooglePlacesLoadObserver();
        return instance.loadPromise;
    }
}
